/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Layout } from '@/data/types/Layout';

export const getForgetMePage = (): Layout => ({
	name: 'Aside',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		aside: [{ name: 'AccountSidebar', id: 'side-bar' }],
		first: [{ name: 'BreadcrumbTrail', id: 'breadcrumb-trail-widget' }],
		second: [{ name: 'ForgetMe', id: 'Forget-Me' }],
		third: [{ name: 'MyAccountFooter', id: 'my_account_footer' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});



